export default [
  {
    path: '/ultimas-visualizacoes',
    component: () => import('@/pages/UltimasVisualizacoes/Index.vue'),
  },
]
